import {EventID} from '@gongxigames/framework/core/types';
import {MenuBarEvents} from '@gongxigames/framework/slot/modules/menubar/MenuBarEvents';

const DEPRECATED_EVENTS: Record<EventID, string> = {
    'General.Sounds.SwitchedTo': 'Please use: UI.sounds.switchedTo',
    'General.Sounds.Disable': 'Please use: UI.sounds.enable',
    'General.Sounds.Enable': 'Please use: UI.sounds.disable',
    [MenuBarEvents.INFO_PAGE_CLICKED]: 'Please use: UI.menu.infoPageClicked',
    [MenuBarEvents.CLOSED]: 'Please use: UI.menu.closed',
    [MenuBarEvents.OPENED]: 'Please use: UI.menu.opened',
    [MenuBarEvents.GAME_RULES_CLICKED]: 'Please use: UI.menu.gameRulesClicked',
    [MenuBarEvents.HISTORY_BUTTON_CLICKED]: 'Please use: UI.menu.historyButtonClicked',
    [MenuBarEvents.LOGOUT_BUTTON_CLICKED]: 'Please use: UI.menu.logoutButtonClicked',
    [MenuBarEvents.SUPPORT_BUTTON_CLICKED]: 'Please use: UI.menu.supportButtonClicked',
    [MenuBarEvents.CASHIER_CLICKED]: 'Please use: UI.menu.cashierClicked',
    [MenuBarEvents.MENU_BAR_CLOSED]: 'Please use: UI.menu.menuBarClosed'
};

export function checkIsEventDeprecated(event: EventID): void {
    const msg = DEPRECATED_EVENTS[event];

    if (msg !== undefined) {
        throw new Error(`Event "${event as string}" is deprecated! ${msg}`);
    }
}